import React, {useEffect, useState} from 'react';
import API from "../../apiService";
import Autocomplete from "react-autocomplete";

const FormTB = () => {

    const [nik, setNik] = useState('')
    const [name, setName] = useState('')
    const [birthDate, setBirthdate] = useState('')

    const [alamatKtp, setAlamatKtp] = useState('')
    const [villageKtpId, setVillageKtpId] = useState('')
    const [dusunKtpId, setDusunKtpId] = useState('')
    const [rtRwKtp, setRtRwKtp] = useState('')

    const [domisiliSama, setDomisiliSama] = useState(false)
    const [alamatDomisili, setAlamatDomisili] = useState('')
    const [villageDomisiliId, setVillageDomisiliId] = useState('')
    const [dusunDomisiliId, setDusunDomisiliId] = useState('')
    const [rtRwDomisili, setRtRwDomisili] = useState('')

    const [phone, setPhone] = useState('')
    const [questions, setQuestions] = useState([])
    const [schools, setSchools] = useState([])
    const [puskesmasId, setPuskesmasId] = useState('')
    const [refPuseksmas, setRefPuskesmas] = useState([])

    const [done, setDone] = useState(false)

    const getQuestions = async () => {
        const res = await API.get("tb/questions");
        if (res.success) {
            setQuestions(res.data)
        }
    }

    const getSchools = async () => {
        const res = await API.get("tb/schools")
        if (res.success) {
            setSchools(res.data)
        }
    }

    const getPuskesmas = async () => {
        const res = await API.get("tb/puskesmas")
        if (res.success) {
            setRefPuskesmas(res.data)
        }
    }

    useEffect(() => {
        getQuestions()
        getSchools()
        getPuskesmas()
    }, [])

    const submit = async () => {
        let terduga = false
        if (questions[2].answer === 'Ya' || questions.filter(q => q.answer === 'Ya').length >= 2) {
            terduga = true
        }

        const res = await API.post("tb/submit", {
            nik: nik,
            result: terduga ? 'Terduga' : 'Tak Terduga',
            puskesmas_id: puskesmasId,
            dusun_ktp_id: dusunKtpId,
            dusun_domisili_id: domisiliSama ? dusunKtpId : dusunDomisiliId,

            name,
            birth_date: birthDate,

            alamat_ktp: alamatKtp,
            village_ktp_id: villageKtpId,
            rt_rw_ktp: rtRwKtp,

            alamat_domisili: domisiliSama ? alamatKtp : alamatDomisili,
            village_domisili_id: domisiliSama ? villageKtpId : villageDomisiliId,
            rt_rw_domisili: domisiliSama ? rtRwKtp : rtRwDomisili,

            questions,
            contact: phone
        })

        if (res.code === 200) {
            setDone(true)
        }
    }

    const reload = () => {
        setNik('')
        setName('')
        setBirthdate('')

        setAlamatKtp('')
        setVillageKtpId('')
        setDusunKtpId('')
        setRtRwKtp('')

        setDomisiliSama(false)
        setAlamatDomisili('')
        setVillageDomisiliId('')
        setDusunDomisiliId('')
        setRtRwDomisili('')

        setPhone('')
        setPuskesmasId('')
        setQuestions([...questions.map(v => ({...v, answer: undefined}))])

        setDone(false)
    }

    const Option = ({option, question, key}) => (
        <label
            className="btn btn-secondary"
            onClick={() => setQuestions([...questions.map(q => ({...q, answer: q.id === question.id ? option : q.answer}))])}
        >
            <input
                type="radio"
                name={`question-${question.id}`}
                value={option}
                defaultChecked={key === 0}
                checked={question.answer === option}
                onClick={() => setQuestions([...questions.map(q => ({...q, answer: q.id === question.id ? option : q.answer}))])}
                onChange={(e) => {
                    if(e.target.checked) {
                        setQuestions([...questions.map(q => ({...q, answer: q.id === question.id ? option : q.answer}))])
                    }
                }} /> {option}
        </label>
    )

    return (
        <div>
            {
                done ? <Done reload={reload}/> : <div className={'card mt-4 mb-4 mx-auto'} style={{maxWidth: 700}}>
                    <div className={'card-header'}>
                        <h1>Deteksi Dini Tuberkulosis</h1>
                        <span className={'text-danger'}>* Indicates required question</span>
                    </div>
                    <div className={'card-body'}>
                        <div className={'form-group'}>
                            <b>NIK <b className={'text-danger'}>*</b></b>
                            <input type={'text'} className={'form-control'} value={nik} onChange={e => setNik(e.target.value)}/>
                        </div>
                        <div className={'form-group'}>
                            <b>Nama <b className={'text-danger'}>*</b></b>
                            <input type={'text'} className={'form-control'} value={name} onChange={e => setName(e.target.value)}/>
                        </div>
                        <div className={'form-group'}>
                            <b>Tanggal Lahir <b className={'text-danger'}>*</b></b>
                            <input type={'date'} className={'form-control'} value={birthDate} onChange={e => setBirthdate(e.target.value)}/>
                        </div>

                        <div className={'form-group'}>
                            <b>Alamat Ktp <b className={'text-danger'}>*</b></b>
                            <textarea className={'form-control'} onChange={e => setAlamatKtp(e.target.value)} rows={3} value={alamatKtp}>
                        </textarea>
                        </div>
                        <div className={'form-group'}>
                            <b>Kelurahan Ktp <b className={'text-danger'}>*</b></b>
                            <SelectDesa onChange={(e) => setVillageKtpId(e.id)}/>
                        </div>
                        <div className={'form-group'}>
                            <b>Dusun Ktp <b className={'text-danger'}>*</b></b>
                            <SelectDusun onChange={(e) => setDusunKtpId(e.id)}/>
                        </div>
                        <div className={'form-group'}>
                            <b>RT/RW Ktp <b className={'text-danger'}>*</b></b>
                            <input type={'text'} className={'form-control'} value={rtRwKtp} onChange={e => setRtRwKtp(e.target.value)}/>
                        </div>
                        <div className="custom-control custom-checkbox mb-3">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id={'domisili_sama'}
                                onChange={e => setDomisiliSama(e.target.checked)}
                                value={1}
                                checked={domisiliSama}
                            />
                            <label className="custom-control-label" htmlFor={'domisili_sama'}>
                                <b style={{fontSize: 16}}>Alamat domisili sama dengan alamat KTP</b>
                            </label>
                        </div>
                        <div className={`form-group ${domisiliSama ? 'd-none' : ''}`}>
                            <b>Alamat Domisili <b className={'text-danger'}>*</b></b>
                            <textarea className={'form-control'} onChange={e => setAlamatDomisili(e.target.value)} rows={3} value={alamatDomisili}>
                        </textarea>
                        </div>
                        <div className={`form-group ${domisiliSama ? 'd-none' : ''}`}>
                            <b>Kelurahan Domisili <b className={'text-danger'}>*</b></b>
                            <SelectDesa onChange={(e) => setVillageDomisiliId(e.id)}/>
                        </div>
                        <div className={`form-group ${domisiliSama ? 'd-none' : ''}`}>
                            <b>Dusun Domisili <b className={'text-danger'}>*</b></b>
                            <SelectDusun onChange={(e) => setDusunDomisiliId(e.id)}/>
                        </div>
                        <div className={`form-group ${domisiliSama ? 'd-none' : ''}`}>
                            <b>RT/RW Domisili <b className={'text-danger'}>*</b></b>
                            <input type={'text'} className={'form-control'} value={rtRwDomisili} onChange={e => setRtRwDomisili(e.target.value)}/>
                        </div>

                        <div className={'form-group'}>
                            <b>No Hp <b className={'text-danger'}>*</b></b>
                            <input type={'text'} className={'form-control'} value={phone} onChange={e => setPhone(e.target.value)}/>
                        </div>
                        <div className={'form-group'}>
                            <b>Puskesmas <b className={'text-danger'}>*</b></b>
                            <select className={'form-control'} onChange={e => setPuskesmasId(e.target.value)}>
                                <option value={''}></option>
                                {
                                    refPuseksmas.map(v => (<option value={v.code}>{v.name}</option>))
                                }
                            </select>
                        </div>
                        {
                            questions.map(v => {
                                if (v.options === 'school') {
                                    return <div className={`form-group ${questions[0]?.answer !== 'sekolah' ? 'd-none' : ''}`}>
                                        <b>{v.question} <b className={'text-danger'}>*</b></b>
                                        <SelectSekolah
                                            onChange={(e) => {
                                                setQuestions([...questions.map(q => ({...q, answer: q.id === v.id ? e.id : q.answer}))])
                                            }}
                                        />
                                    </div>
                                }
                                return (
                                    <div className={`form-group`}>
                                        <b className={'d-block'}>{v.question}</b>
                                        <div className="btn-group" data-toggle="buttons">
                                            <div>
                                                {
                                                    JSON.parse(v.options).map((o, k) => (<Option key={k} question={v} option={o}/>))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <button className={'btn btn-success'} onClick={submit}>
                            Submit
                        </button>
                    </div>
                </div>
            }
        </div>
    )
}

const SelectDesa = ({onChange}) => {

    const [icd, setIcd] = useState('')
    const [dataIcd, setDataIcd] = useState([])
    const [village, setVillage] = useState([
        {
            name: "",
        },
    ])
    let timeout

    const retrieveDataAsynchronouslyIcd = async (e) => {
        const res = await API.get(`demograph/villages/search/${e}`);
        if (res.code === 200) {
            setDataIcd(res.data)
        } else {
            console.error("Cannot load data from remote source");
        }
    }

    return (
        <Autocomplete
            inputProps={{
                className: "form-control",
                placeholder: "ketikkan minimal 3 huruf",
            }}
            ref={(input) => {
                setIcd(input)
            }}
            getItemValue={(item) => `${item.id} - ${item.name}, ${item.district.name}, ${item.district.city.name}`}
            items={dataIcd}
            renderItem={(item, isHighlighted) => (
                <div
                    key={item.id}
                    style={{background: isHighlighted ? "lightgray" : "white", marginTop: 8}}
                >
                    {item.id} - {item.name}, {item.district.name}, {item.district.city.name}
                </div>
            )}
            value={village[0].name}
            onChange={(evt) => {
                const newIcd = village.map((icd, sidx) => {
                    if (0 !== sidx) return icd;
                    return {
                        ...icd,
                        name: evt.target.value,
                    };
                });
                setVillage(newIcd)

                const par = evt.target.value;
                if (timeout) clearTimeout(timeout);
                timeout = setTimeout(() => {
                    if (par.length > 2) {
                        retrieveDataAsynchronouslyIcd(par);
                    }
                }, 500);
            }}
            onSelect={(evt) => {
                const val = evt.split(' - ');
                const newIcd = village.map((icd, sidx) => {
                    if (0 !== sidx) return icd;
                    return {
                        ...icd,
                        name: val[1],
                        id: val[0]
                    };
                });

                setVillage(newIcd)
                onChange(newIcd[0])
            }}
            menuStyle={{
                borderRadius: "3px",
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                background: "rgba(255, 255, 255, 0.9)",
                padding: "2px 0",
                fontSize: "90%",
                // position: "absolute",
                overflow: "auto",
                zIndex: "100",
                maxHeight: "110%", // TODO: don't cheat, let it flow to the bottom
            }}
            wrapperStyle={{
                overflow: "auto",
                maxHeight: '300px'
            }}
        />
    )
}

const SelectDusun = ({onChange}) => {

    const [icd, setIcd] = useState('')
    const [dataIcd, setDataIcd] = useState([])
    const [village, setVillage] = useState([
        {
            name: "",
        },
    ])
    let timeout

    const retrieveDataAsynchronouslyIcd = async (e) => {
        const res = await API.get(`tb/dusun/${e}`);
        if (res.code === 200) {
            setDataIcd(res.data)
        } else {
            console.error("Cannot load data from remote source");
        }
    }

    return (
        <Autocomplete
            inputProps={{
                className: "form-control",
                placeholder: "ketikkan minimal 3 huruf",
            }}
            ref={(input) => {
                setIcd(input)
            }}
            getItemValue={(item) => `${item.id} - ${item.name}, ${item.village?.name}`}
            items={dataIcd}
            renderItem={(item, isHighlighted) => (
                <div
                    key={item.id}
                    style={{background: isHighlighted ? "lightgray" : "white", marginTop: 8}}
                >
                    {item.id} - {item.name}, {item.village?.name}
                </div>
            )}
            value={village[0].name}
            onChange={(evt) => {
                const newIcd = village.map((icd, sidx) => {
                    if (0 !== sidx) return icd;
                    return {
                        ...icd,
                        name: evt.target.value,
                    };
                });
                setVillage(newIcd)

                const par = evt.target.value;
                if (timeout) clearTimeout(timeout);
                timeout = setTimeout(() => {
                    if (par.length > 2) {
                        retrieveDataAsynchronouslyIcd(par);
                    }
                }, 500);
            }}
            onSelect={(evt) => {
                const val = evt.split(' - ');
                const newIcd = village.map((icd, sidx) => {
                    if (0 !== sidx) return icd;
                    return {
                        ...icd,
                        name: val[1],
                        id: val[0]
                    };
                });

                setVillage(newIcd)
                onChange(newIcd[0])
            }}
            menuStyle={{
                borderRadius: "3px",
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                background: "rgba(255, 255, 255, 0.9)",
                padding: "2px 0",
                fontSize: "90%",
                // position: "absolute",
                overflow: "auto",
                zIndex: "100",
                maxHeight: "110%", // TODO: don't cheat, let it flow to the bottom
            }}
            wrapperStyle={{
                overflow: "auto",
                maxHeight: '300px'
            }}
        />
    )
}

const SelectSekolah = ({onChange}) => {

    const [icd, setIcd] = useState('')
    const [dataIcd, setDataIcd] = useState([])
    const [village, setVillage] = useState([
        {
            name: "",
        },
    ])
    let timeout

    const retrieveDataAsynchronouslyIcd = async (e) => {
        const res = await API.get(`tb/schools/${e}`);
        if (res.code === 200) {
            setDataIcd(res.data)
        } else {
            console.error("Cannot load data from remote source");
        }
    }

    return (
        <Autocomplete
            inputProps={{
                className: "form-control",
                placeholder: "ketikkan minimal 3 huruf",
            }}
            ref={(input) => {
                setIcd(input)
            }}
            getItemValue={(item) => `${item.id} - ${item.name}`}
            items={dataIcd}
            renderItem={(item, isHighlighted) => (
                <div
                    key={item.id}
                    style={{background: isHighlighted ? "lightgray" : "white", marginTop: 8}}
                >
                    {item.id} - {item.name}
                </div>
            )}
            value={village[0].name}
            onChange={(evt) => {
                const newIcd = village.map((icd, sidx) => {
                    if (0 !== sidx) return icd;
                    return {
                        ...icd,
                        name: evt.target.value,
                    };
                });
                setVillage(newIcd)

                const par = evt.target.value;
                if (timeout) clearTimeout(timeout);
                timeout = setTimeout(() => {
                    if (par.length > 2) {
                        retrieveDataAsynchronouslyIcd(par);
                    }
                }, 500);
            }}
            onSelect={(evt) => {
                const val = evt.split(' - ');
                const newIcd = village.map((icd, sidx) => {
                    if (0 !== sidx) return icd;
                    return {
                        ...icd,
                        name: val[1],
                        id: val[0]
                    };
                });

                setVillage(newIcd)
                onChange(newIcd[0])
            }}
            menuStyle={{
                borderRadius: "3px",
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                background: "rgba(255, 255, 255, 0.9)",
                padding: "2px 0",
                fontSize: "90%",
                // position: "absolute",
                overflow: "auto",
                zIndex: "100",
                maxHeight: "110%", // TODO: don't cheat, let it flow to the bottom
            }}
            wrapperStyle={{
                overflow: "auto",
                maxHeight: '300px'
            }}
        />
    )
}

const Done = ({reload}) => (
    <div className={'card mt-4 mb-4 mx-auto'} style={{maxWidth: 700}}>
        <div className={'card-header'}>
            <h1>Berhasil submit form</h1>
        </div>
        <div className={'card-body'}>
            Isi form lagi?<br/>
            <button className={'btn btn-success'} onClick={reload}>
                Isi Lagi
            </button>
        </div>
    </div>
)

export default FormTB